angular.module('pe4h').controller('ForgotPassword', function($scope, $rootScope, $state, $http, configuration, AuthService) {
    $scope.forgotPassword = function() {
        $http({
            url: configuration.webApi.auth.reset_password,
            method: "POST",
            data: {
                "Email": $scope.mail
            },
        }).success(function(res, status, headers, config) {
            console.log(res);

        }).error(function(error, status, headers, config) {
            $scope.alertErrorFromServer(error);
            //authFactory.logout();
        });
    }
});
